import styled from 'styled-components';
import React from 'react';
import colors from '../../../../helpers/colors';

const Container = styled.div`
`;

const Title = styled.h1`
    font-size: 32px;
    font-weight: 900;
    color: ${colors.mvBlack};
`;

const ByDateWrapper = styled.div`
    display: flex;
    align-items: center;
    margin-top: 10px;
    width: 65%;

    @media screen and (max-width: 800px) {
        width: 100%;
    }

    @media screen and (max-width: 640px) {
        flex-direction: row;
        align-items: flex-start;
        margin-top: 20px;
    }
`;

const Date = styled.p`
    color: ${colors.paragraphTextColor};
    font-size: 15px;
    font-weight: 500;
`;

const Divider = styled.div`
    margin: 0 25px;
    color: ${colors.paragraphTextColor};
`;


const HeadingSection = ({ title, date, by }) => {
    return (
        <Container>
            <Title>{title}</Title>
            <ByDateWrapper>
                <Date>{date}</Date> 
                <Divider>|</Divider>
                <Date>{by}</Date>
            </ByDateWrapper>

        </Container>
    );
};

export default HeadingSection;
